export class RelatedInput {

    constructor(group, component, model, props, columns, allSelectable = true, isFilter = true) {
        this.group = group;
        this.component = component;
        this.model = model;
        this.props = props;
        this.allSelectable = allSelectable;
        this.columns = columns;
        this.isDisabled = false;
        this.isFilter = isFilter
    }
}
